import { useLingui } from '@lingui/react/macro';

import { TOfferDataRequirement } from '../../../../../types';
import DocumentRequirement from '../../../DocumentRequirement/DocumentRequirement';
import { documentTypes } from '../../../tradingHistory.helpers';

type TProps = {
  isOptional: boolean;
  isSubmitted: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
};

export const BwaSusaAnnual = ({ isOptional, isSubmitted, status }: TProps) => {
  const { t } = useLingui();

  return (
    <DocumentRequirement
      title={t`BWAs and SuSas from the last 2 years`}
      documentType={documentTypes.jaehrliche_bwa_susa_hochladen}
      isOptional={isOptional}
      isSubmitted={isSubmitted}
      status={status}
    >
      <>
        <ul>
          <li>
            Alle BWAs sollten Firmenname, Umsatzerlöse, Wareneinkauf, Kosten
            inkl. Abschreibungen, Zinsaufwände & vorläufiges Ergebnis zeigen
          </li>
          <li>
            Alle SuSas sollten EB-Wert, kumulierte Jahreswerte & Saldo
            beinhalten und im korrekten Format eingereicht werden
          </li>
        </ul>

        <h4>Beispiel SuSa Format Datev:</h4>
        <ul>
          <li>Korrekt: alle bebuchten Konten oder Sachkonten</li>
          <li>Falsch: individueller Stapel, Konten ohne Null-Salden</li>
        </ul>
      </>
    </DocumentRequirement>
  );
};
